import clsx from 'clsx';
import React, { useState } from 'react';

export interface Tab {
    label: string;
    content: React.ReactNode;
}

interface SystemMultiTabProps {
    tabs: Tab[];
    activeIndex: number;
    handleChange: (index: number) => void;

    labelOptions?: {
        itemClassName?: string;
        containerClassName?: string;
    }
    contentOptions?: {
        containerClassName?: string;
    }
}

export const SystemMultiTab: React.FC<SystemMultiTabProps> = (props) => {
    const {
        tabs,
        activeIndex,
        handleChange,
        labelOptions = {},
        contentOptions = {}
    } = props;

    return (
        <div className="w-full mx-auto">
            <div
                className={clsx(
                    "bg-cs-200 flex border-b border-b-cs-300 divide-x divide-cs-300 border-cs-normal-gray",
                    labelOptions.containerClassName
                )}
            >
                {tabs.map((tab, index) => (
                    <button
                        key={`${tab.label}-${index}`}
                        type="button"
                        className={clsx(
                            `font-bold px-4 py-2 border-b-2 cursor-pointer transition-colors duration-300`,
                            activeIndex === index
                                ? 'border-b-cs-500 text-cs-500'
                                : 'border-b-transparent text-cs-800 hover:text-cs-500',
                            labelOptions.itemClassName
                        )}
                        onClick={() => handleChange(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div
                className={clsx("p-4", contentOptions.containerClassName)}
            >
                {tabs[activeIndex]?.content}
            </div>
        </div >
    );
};

interface ControlledSystemMultiTabProps extends Omit<SystemMultiTabProps, 'activeIndex' | 'handleChange'> {
    initialIndex?: number;
}

export const ControlledSystemMultiTab: React.FC<ControlledSystemMultiTabProps> = (props) => {
    const {
        initialIndex = 0,
        ...restOfProps
    } = props;

    const [activeIndex, setActiveIndex] = useState(initialIndex);

    const handleChange = (index: number) => {
        setActiveIndex(index);
    }

    return (
        <SystemMultiTab
            {...restOfProps}
            activeIndex={activeIndex}
            handleChange={handleChange}
        />
    )
}